import {
  BooksIcon, TrophyIcon, DiplomaIcon, HousingIcon, InternshipIcon, MedicalIcon,
  PlaneIcon, TechIcon, TestPrepIcon, TransportIcon, TutoringIcon, WinterIcon, OtherIcon, RocketIcon,
} from "../lib/icons";

/**
 * Canonical list of fundraising campaign categories used by both the
 * CreateCampaign wizard (students pick one) and the donor browse filter
 * on the Featured Campaigns section.
 *
 * Source: "Categories for Fundraising Campaigns.docx" (2026-02).
 * When we wire the backend, this will move to a MongoDB collection —
 * schema unchanged.
 *
 * Fields:
 *   slug  — stable identifier used in query params, DB refs, and campaign
 *           `category` field. Kebab-case.
 *   label — display copy shown to students and donors.
 *   Icon  — Phosphor Fill component (lib/icons.js) (React) rendered inside chips and cards.
 *   subs  — optional sub-category strings a student can pick from.
 *   other — true for the free-text fallback (100-char limit enforced in
 *           the wizard).
 */
export const CAMPAIGN_CATEGORIES = [
  { slug: "books",           label: "Books & Study Aids",         Icon: BooksIcon,      subs: [] },
  { slug: "extracurricular", label: "Extracurricular Activities", Icon: TrophyIcon,        subs: ["Dues", "Equipment/Gear"] },
  { slug: "first-gen",       label: "First Generation College Student", Icon: RocketIcon, subs: [] },
  { slug: "graduation",      label: "Graduation Expenses",        Icon: DiplomaIcon, subs: [] },
  { slug: "housing",         label: "Housing",                    Icon: HousingIcon,          subs: ["Dorm Room Essentials", "Off Campus Apartment Essentials", "Rent"] },
  { slug: "internship",      label: "Internship",                 Icon: InternshipIcon,     subs: ["Expenses", "Travel", "Housing", "Clothes"] },
  { slug: "medical",         label: "Medical Expenses",           Icon: MedicalIcon,    subs: [] },
  { slug: "study-abroad",    label: "Study Abroad",               Icon: PlaneIcon,         subs: ["Transportation", "Luggage", "Tuition"] },
  { slug: "tech",            label: "Tech Expenses",              Icon: TechIcon,        subs: ["Computer Purchase or Repair", "Phone/Tablet Purchase or Repair"] },
  { slug: "test-prep",       label: "Test Preparation",           Icon: TestPrepIcon,        subs: ["Courses", "Materials"] },
  { slug: "transportation",  label: "Transportation",             Icon: TransportIcon,           subs: [] },
  { slug: "tutoring",        label: "Tutoring",                   Icon: TutoringIcon,    subs: [] },
  { slug: "winter-gear",     label: "Winter Gear",                Icon: WinterIcon,     subs: [] },
  { slug: "other",           label: "Other",                      Icon: OtherIcon,        subs: [], other: true },
];

export const CATEGORY_BY_SLUG = Object.fromEntries(
  CAMPAIGN_CATEGORIES.map((c) => [c.slug, c])
);
